module.exports = __webpack_public_path__ + "static/img/banner (2).253e912.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner (2).jpg
// module id = BHvn
// module chunks = 73